// extracted by mini-css-extract-plugin
export default {"main":"Hero_main__i6iL8","button":"Hero_button__ivA5g"};